<template>
  <b-button
          :variant="variant"
          :block="block"
          :disabled="disabledButton"
          :size="size"
          :type="type"
          @click.prevent="$emit('submit')"
  >
    <span v-show="loading">
      <font-awesome-icon icon="spinner" spin></font-awesome-icon>&nbsp;
    </span>
    <span v-show="!loading">
      <slot v-show="!loading">Submit</slot>
    </span>
  </b-button>
</template>

<script>
export default {
  name: 'LoadingButton',
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: null
    },
    variant: {
      type: String,
      default: 'orange'
    },
    type: {
      type: String,
      default: 'button'
    }
  },
  computed: {
    disabledButton () {
      return this.loading || this.disabled;
    }
  }
};
</script>